export const env = {
  API_URL: process.env.API_URL,
  SKEEM_URL: process.env.API_URL + "/skeem",
  WEBSITE_URL: process.env.WEBSITE_URL,
  STRIPE_PUBLIC_KEY:
    (typeof window !== "undefined" ? (window as any).STRIPE_PUBLIC_KEY : undefined) ||
    process.env.STRIPE_PUBLIC_KEY,
  GOOGLE_OAUTH_CALLBACK_URL: process.env.GOOGLE_OAUTH_CALLBACK_URL,
}